export const getBase64 = (file: File, maxSize?: number) => {
	const defaultSize = 10000000;
	return new Promise<string>((resolve, reject) => {
		if (file.size > (maxSize || defaultSize)) {
			reject(`max size is ${maxSize || defaultSize} bytes`);
		}
		let baseURL = "";
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => {
			baseURL = (reader.result as string | null) || "";
			resolve(baseURL);
		};
	});
};
